import type { z } from 'zod';
import type {
  QueryStoreQueryLeafsModel,
  QueryStoreQueryModel,
} from '../_models/query-store';

type Query = z.infer<typeof QueryStoreQueryModel>;
type QueryLeafs = z.infer<typeof QueryStoreQueryLeafsModel>;

const QUERY_FIELDS: Array<[keyof Query, keyof QueryLeafs]> = [
  ['policyIds', 'policyIds'],
  ['expenditureNatureIds', 'expenditureNatureIds'],
  ['expenditureItemNatureIds', 'expenditureItemNatureIds'],
  ['expenditurePurposeIds', 'expenditurePurposeIds'],
  ['expenditureBudgetPurposeIds', 'expenditureBudgetPurposeIds'],
  ['organizationIds', 'organizationIds'],
  ['relatedOrganizationIds', 'relatedOrganizationIds'],
  ['otherResponsibleOrganizationIds', 'otherResponsibleOrganizationIds'],
  ['pinpointKeys', 'pinpointKeys'],
];

export const generateQueryAndLeafs = (value: Query) => {
  const queryLeafs: QueryLeafs = {};
  const query: Query = {};

  for (const [queryField, queryLeafField] of QUERY_FIELDS) {
    const queryFieldValues = value[queryField];
    if (queryFieldValues?.length) {
      queryLeafs[queryLeafField] = queryFieldValues
        .flatMap((item) => {
          const leafElement = item.at(-1);
          return leafElement ? [leafElement] : [];
        })
        .sort();
      query[queryField] = queryFieldValues;
    }
  }

  if (Object.keys(query).length) {
    return { queryLeafs, query };
  }
  return null;
};
